module.exports = __webpack_public_path__ + "front/img/20.bak.df02d625.jpg";